import { DownloadOutlined } from "@ant-design/icons";
import { notification, Popover, Tooltip } from "antd";
import SVG from "components/common/SVG";
import { allUserRoles } from "constants/phase";
import { APP_VERSION } from "constants/v2/appConstants";
import amplitude from "externals/amplitude";
import { useNavigate, useOutletContext } from "react-router-dom";

import styles from "./style.module.scss";
const ActionsContainer = ({
  setShowEditWorkspaceModal,
  workspace,
  setShowAssignUserModal,
  setShowDeleteModal,
  downloadOrganizationCSV,
}) => {
  const navigation = useNavigate();
  const { currentRole } = useOutletContext();

  const downloadOrganizationalCSV = async (id) => {
    const data = await downloadOrganizationCSV({ id });
    if (data.value.status) {
      notification["success"]({ message: data.value.message });
      amplitude.logEvent("content_downloaded", {
        content_id: workspace?.workspaceId,
        content_type: "csv",
        origin: "workspace_report_download",
        version: APP_VERSION.V2,
      });
      window.open(data?.value?.data);
    } else {
      notification["error"]({ message: data.value.message });
    }
  };
  return (
    <div className={styles.actionContainer}>
      <Tooltip placement="top" title={"Edit Workspace"} arrow>
        <div className={styles.item} onClick={() => setShowEditWorkspaceModal(workspace)}>
          <SVG className={styles.actionIcon} iconName={"images/edit.svg"} />
        </div>
      </Tooltip>

      <Tooltip placement="top" title={"Assign User"} arrow>
        <div className={styles.item} onClick={() => setShowAssignUserModal(workspace)}>
          <SVG className={styles.actionIcon} iconName={"images/assign-user.svg"} />
        </div>
      </Tooltip>

      <Tooltip placement="top" title={"More Actions"} arrow>
        <Popover
          overlayStyle={{ borderRadius: "4px", padding: "12px 10px" }}
          content={
            <div className={styles.popoverContainer}>
              <div className={styles.popoverItem}>
                <div className={styles.iconCont}>
                  <SVG className={styles.actionsIcon} iconName={"images/view.svg"} />
                </div>
                <div
                  onClick={() =>
                    navigation(`/workspaces-profile/${workspace?.workspaceId}/basicinfo`, { replace: true })
                  }
                  className={styles.text}
                >
                  View Workspace profile
                </div>
              </div>
              {currentRole === allUserRoles.superAdmin && (
                <div className={styles.popoverItem} onClick={() => downloadOrganizationalCSV(workspace?.workspaceId)}>
                  <div className={styles.iconCont}>
                    <DownloadOutlined />
                  </div>
                  <div className={styles.text}>Download organization csv</div>
                </div>
              )}
              <div className={styles.popoverItem} onClick={() => setShowDeleteModal(workspace)}>
                <div className={styles.iconCont}>
                  <SVG className={styles.actionsIcon} iconName={"images/delete.svg"} />
                </div>
                <div className={styles.text}>Delete</div>
              </div>
            </div>
          }
          placement="bottomRight"
          trigger="click"
          showArrow={false}
        >
          <div className={styles.item}>
            <SVG className={styles.actionIcon} iconName={"images/actions.svg"} />
          </div>
        </Popover>
      </Tooltip>
    </div>
  );
};

export default ActionsContainer;
